import { useEffect } from "react";
import { selectVariant } from "../../utils/adVariant";
import { toPlacementId } from "../../utils/moeVideoPlacement";

const renderFloorAd = (blockId) => {
    window.yaContextCb.push(() => {
        Ya.Context.AdvManager.render({
            blockId,
            type: "floorAd",
            platform: "touch",
        });
    });
};

const MoeVideo = ({ placements, isFull, isDesktop, closeSecOffset = 10, yaFloorAdOnEmpty, yaFloorAdOnError }) => {
    // selectVariant пропускает скаляр насквозь: из БД сюда приходит готовый id (строкой).
    const placement = toPlacementId(selectVariant(placements, isFull, isDesktop));

    useEffect(() => {
        if (!placement) {
            return;
        }
        const script = document.createElement("script");
        script.src = "https://cdn1.moe.video/p/cr.js";
        script.onload = () => {
            if (window.addContentRoll) {
                const config = {
                    width: "100%",
                    placement: placement,
                    promo: true,
                    advertCount: 50,
                    slot: "sticky",
                    sound: "onclick",
                    deviceMode: "all",
                    background: "none",
                    fly: {
                        mode: "stick",
                        width: 445,
                        closeSecOffset: closeSecOffset,
                        position: "bottom-right",
                        indent: {
                            left: 0,
                            right: 0,
                            top: 0,
                            bottom: 0,
                        },
                        positionMobile: "bottom",
                    },
                    style: { fly: { zindex: 100 } },
                    adEmpty: yaFloorAdOnEmpty ? () => renderFloorAd(yaFloorAdOnEmpty) : undefined,
                    adError: yaFloorAdOnError ? () => renderFloorAd(yaFloorAdOnError) : undefined,
                };
                window.addContentRoll(config);
            }
        };
        document.body.appendChild(script);
    }, [placement]);

    return null;
};

export default MoeVideo;
